// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__jNjnU","slider":"Switch_slider__Xmg2b","round":"Switch_round__UXNIK"};